import { render } from "./VolForm.vue?vue&type=template&id=50206782&scoped=true"
import script from "./VolForm.vue?vue&type=script&lang=js"
export * from "./VolForm.vue?vue&type=script&lang=js"

import "./VolForm.vue?vue&type=style&index=0&id=50206782&lang=less&scoped=true"

import exportComponent from "/root/workspace/KpiManage-vue_PVju/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50206782"]])

export default __exports__